import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./EditStateGovScholarship.css";

const EditStateGovScholarship = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    youtubeLink: "",
    officialLink: "",
    state: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch existing scholarship data on component load
  useEffect(() => {
    const fetchScholarship = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/scholarships/singledata/${id}`
        );
        setFormData({
          title: response.data.title,
          description: response.data.description,
          youtubeLink: response.data.youtubeLink,
          officialLink: response.data.officialLink,
          state: response.data.state,
        });
      } catch (error) {
        console.error("Error fetching scholarship:", error);
        alert("An error occurred while loading the scholarship data.");
      }
    };
    fetchScholarship();
  }, [API_BASE_URL, id]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Submit the edited scholarship data
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axios.put(`${API_BASE_URL}/scholarships/${id}`, formData);
      alert("Scholarship updated successfully!");
      navigate("/student-scholarship/all-state-government");
    } catch (error) {
      console.error("Error updating scholarship:", error);
      alert("An error occurred while updating the scholarship.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="edit-state-gov-scholarship-main-container">
      <div className="edit-state-gov-heading-main-div">
        <h4>Edit State Government Scholarship</h4>
        <div className="header-main-btns">
          <button
            onClick={() => navigate("/student-scholarship/state-government")}
          >
            State Gov Scholarship
          </button>
          <button
            onClick={() =>
              navigate("/student-scholarship/all-state-government")
            }
          >
            All State Gov Scholarship
          </button>
        </div>
      </div>
      <div className="edit-state-gov-scholarship-inner">
        <form onSubmit={handleSubmit}>
          <div className="edit-state-gov-input">
            <label>
              <b>Title</b>
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter Title"
              required
            />
          </div>
          <div className="edit-state-gov-input">
            <label>
              <b>Description</b>
            </label>
            <textarea
              name="description"
              style={{ height: "120px" }}
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Type description"
              required
            ></textarea>
          </div>
          <div className="edit-state-gov-input">
            <label>
              <b>YouTube Link</b>
            </label>
            <input
              type="text"
              name="youtubeLink"
              value={formData.youtubeLink}
              onChange={handleInputChange}
              placeholder="Enter YouTube Link"
            />
          </div>
          <div className="edit-state-gov-input">
            <label>
              <b>Other Link</b>
            </label>
            <input
              type="text"
              name="officialLink"
              value={formData.officialLink}
              onChange={handleInputChange}
              placeholder="Enter Other Link"
            />
          </div>

          <div className="edit-state-gov-input">
            <label>
              <b>State</b>
            </label>

            <select
              name="state"
              value={formData.state}
              onChange={handleInputChange}
              required
            >
              <option value="">-- Select State / UT --</option>

              <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
              <option value="Andhra Pradesh">Andhra Pradesh</option>
              <option value="Arunachal Pradesh">Arunachal Pradesh</option>
              <option value="Assam">Assam</option>
              <option value="Bihar">Bihar</option>
              <option value="Chandigarh">Chandigarh</option>
              <option value="Chhattisgarh">Chhattisgarh</option>
              <option value="Dadra and Nagar Haveli and Daman and Diu">
                Dadra and Nagar Haveli and Daman and Diu
              </option>
              <option value="Delhi">Delhi</option>
              <option value="Goa">Goa</option>
              <option value="Gujarat">Gujarat</option>
              <option value="Haryana">Haryana</option>
              <option value="Himachal Pradesh">Himachal Pradesh</option>
              <option value="Jammu and Kashmir">Jammu and Kashmir</option>
              <option value="Jharkhand">Jharkhand</option>
              <option value="Karnataka">Karnataka</option>
              <option value="Kerala">Kerala</option>
              <option value="Ladakh">Ladakh</option>
              <option value="Lakshadweep">Lakshadweep</option>
              <option value="Madhya Pradesh">Madhya Pradesh</option>
              <option value="Maharashtra">Maharashtra</option>
              <option value="Manipur">Manipur</option>
              <option value="Meghalaya">Meghalaya</option>
              <option value="Mizoram">Mizoram</option>
              <option value="Nagaland">Nagaland</option>
              <option value="Odisha">Odisha</option>
              <option value="Puducherry">Puducherry</option>
              <option value="Punjab">Punjab</option>
              <option value="Rajasthan">Rajasthan</option>
              <option value="Sikkim">Sikkim</option>
              <option value="Tamil Nadu">Tamil Nadu</option>
              <option value="Telangana">Telangana</option>
              <option value="Tripura">Tripura</option>
              <option value="Uttar Pradesh">Uttar Pradesh</option>
              <option value="Uttarakhand">Uttarakhand</option>
              <option value="West Bengal">West Bengal</option>
            </select>
          </div>

          <div className="new-chapter-form-buttons">
            <button
              type="submit"
              className="new-chapter-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
            <button
              type="button"
              className="new-chapter-cancel-btn"
              onClick={() =>
                navigate("/student-scholarship/all-state-government")
              }
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStateGovScholarship;
